import type { getGroupPrefetchParams } from './groupService';

import { GroupService } from './groupService';
import { GroupKey } from './keys';

export function getGroupPrefetch(params: getGroupPrefetchParams) {
  const { id, initialData, queryClient } = params;

  queryClient.prefetchQuery({
    queryKey: [GroupKey.GROUPS, id],
    queryFn: () => GroupService.getGroup(id).then((response) => response.data),
    initialData: initialData,
    staleTime: 60000,
  });
}
